const purple = '#6b80d2'
const pink = '#c88bc4'
const accentPink = '#c675c0'
const darkPink = '#ac76a8'
const darkblue = '#85c0f2'
const lightblue = '#bbdef2'

export { purple, pink, darkblue, lightblue, darkPink, accentPink }
